import { Tooltip } from "@mui/material";

const InputLabel = (props) => {
  return (
    <Tooltip
      title={
        props.item.help === undefined ? (
          ""
        ) : (
          <div className="text-right">
            <h4 className="p-[5px] text-[12px]">{props.item.help.title}</h4>
            <hr></hr>
            <p className="p-[5px]">{props.item.help.body}</p>
          </div>
        )
      }
      placement="left-start"
      arrow
    >
      <label className="text-[14px] dark:text-[#D1D4C9] text-edit_input_label col-span-full sm:col-auto mb-1 mt-5 sm:mb-0 sm:mt-0 relative">
        <span>{props.item.label}</span>
        {props.item.required && (
          <span className="text-red-500 text-base absolute top-0">*</span>
        )}
        {props.item.help && (
          <i
            className="fa fa-info text-amber-600 w-4 h-4 text-center pt-[2px] rounded-full"
            aria-hidden="true"
          ></i>
        )}
      </label>
    </Tooltip>
  );
};

export default InputLabel;
